import { Alert, AlertDescription, Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { LabeledValue } from '@/components/ui/labeled-value';
import type { PersonalIdentity } from '@/services/api/fiu-utr';

interface ClientIdentityCardProps {
  identity: PersonalIdentity | null;
}

// Tonal identity card, or the blocking no-identity warning (this 404 is
// blocking, unlike the silent no-Sumsub-applicant case).
export const ClientIdentityCard = ({ identity }: ClientIdentityCardProps) => {
  if (!identity) {
    return (
      <Alert className="max-w-[900px] border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-400">
        <AlertDescription>No personal identity record found for this PID. The filing cannot be generated without it.</AlertDescription>
      </Alert>
    );
  }
  const address = identity.addressOfResidency;
  return (
    <Card className="max-w-[900px] bg-muted/40">
      <CardHeader>
        <CardTitle>
          {identity.firstName} {identity.lastName}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-4">
          <LabeledValue label="Born">
            {identity.birthInfo?.date} {identity.birthInfo?.locality}
          </LabeledValue>
          <LabeledValue label="Nationality">
            {identity.citizenship}
            {identity.citizenship2 ? ` / ${identity.citizenship2}` : ''}
          </LabeledValue>
          <LabeledValue label="Residence">{address?.country}</LabeledValue>
          <LabeledValue label="Address">
            {address?.addressLines?.join(', ')}, {address?.locality} {address?.postalCode}
          </LabeledValue>
          <LabeledValue label="Phone">
            {identity.phoneNumber?.areaCode} {identity.phoneNumber?.mobilePhone}
          </LabeledValue>
        </div>
      </CardContent>
    </Card>
  );
};
ClientIdentityCard.displayName = 'ClientIdentityCard';
